import {FixedAssetList, FixedAssetRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {TableCell} from "@mui/material";
import {SoftChip, Tone} from "../../../../components/kit";
import {numSx} from "../tax_submission/labels";
import {useApiManager} from "../../../../components/utils/api";
import {fmtAmt} from "../../../../components/utils/numbers";
import {dateToString} from "../../../../components/utils/dates";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";

const STATUS: Record<string, { label: string, tone: Tone }> = {
    ACTIVO: {label: "Activo", tone: "success"},
    AMORTIZADO: {label: "Amortizado", tone: "neutral"},
    DADO_DE_BAJA: {label: "Dado de baja", tone: "error"},
};

const METHOD: Record<string, string> = {LINEAL: "Lineal", DEGRESIVO: "Degresivo"};

export const FixedAssetListPage = () => {
    const apiManager = useApiManager();

    const listConfig: AppListConfig<FixedAssetList> = {
        title: "Activos fijos",
        onClick: "/app/admin/accounting/fixed-asset",
        headers: [
            {title: "Nombre"},
            {title: "Fecha adquisición", width: 130},
            {title: "Valor adq.", align: "right", width: 110},
            {title: "Valor residual", align: "right", width: 110},
            {title: "Vida útil (meses)", align: "right", width: 110},
            {title: "Cuota del mes", align: "right", width: 110},
            {title: "Método", width: 100},
            {title: "Estado", width: 100},
        ],
        decorator: (bean: FixedAssetList) => (
            <>
                <TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
                    {bean.name}
                </TableCell>
                <TableCell>{dateToString(bean.acquisitionDate)}</TableCell>
                <TableCell align="right" sx={numSx}>{fmtAmt(bean.acquisitionValue)}</TableCell>
                <TableCell align="right" sx={numSx}>{fmtAmt(bean.residualValue) || "—"}</TableCell>
                <TableCell align="right" sx={numSx}>{bean.usefulLifeMonths}</TableCell>
                <TableCell align="right" sx={numSx}>{fmtAmt(bean.currentMonthAmortization) || "—"}</TableCell>
                <TableCell>{METHOD[bean.amortizationMethod || ""] || bean.amortizationMethod}</TableCell>
                <TableCell>
                    <SoftChip label={STATUS[bean.status]?.label || bean.status} tone={STATUS[bean.status]?.tone || "neutral"}/>
                </TableCell>
            </>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            const ctrl = apiManager.factory(FixedAssetRestControllerApiFactory);
            return ctrl.pageFixedAsset(currentPage, size, undefined, undefined, undefined, term, showDismissed);
        },
    };

    return <AppList config={listConfig}/>;
};
